import { createFileRoute } from '@tanstack/react-router';

import { MyTimeMobilePage } from '@/pages/my-time/my-time-mobile-page';
import { MyTimePage } from '@/pages/my-time/my-time-page';
import { useMobile } from '@/shared/lib/use-mobile';

function MyTimeRoute() {
  const isMobile = useMobile();
  return isMobile ? <MyTimeMobilePage /> : <MyTimePage />;
}

export const Route = createFileRoute('/my/time')({ component: MyTimeRoute });
